import Image from './Image'
import PDF from './PDF'
import Video from './Video'
import Audio from './Audio'
import OtherFile from './OtherFile'
import Font from './Font'

const mimetypeLookup = {
  'image/gif': Image,
  'image/jpeg': Image,
  'image/png': Image,
  'image/svg+xml': Image,
  'image/webp': Image,
  'application/pdf': PDF,
  'video/x-msvideo': Video,
  'video/mpeg': Video,
  'video/ogg': Video,
  'video/webm': Video,
  'video/3gpp': Video,
  'video/3gpp2': Video,
  'video/mp4': Video,
  'audio/mp3': Audio,
  'audio/ogg': Audio,
  'audio/wav': Audio,
  'audio/wave': Audio,
  'audio/flac': Audio,
  'font/woff': Font,
  'font/woff2': Font,
  'font/otf': Font,
  'font/ttf': Font
}

export default (mimetype) => {
  return mimetypeLookup[mimetype] || OtherFile
}
